import { render, staticRenderFns } from "./TimetableTemplateList.vue?vue&type=template&id=db8fc1c4"
import script from "@/controllers/timetable_template/timetable-template-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/timetable_template/timetable-template-list.js?vue&type=script&lang=js&external"
import style0 from "./TimetableTemplateList.vue?vue&type=style&index=0&id=db8fc1c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports